import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-950/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(255,255,255,0.05)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-vip-crown-2-fill text-background-950 text-lg md:text-xl"></i>
            </div>
            <div>
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-50 tracking-wide group-hover:text-primary-400 transition-colors">
                金沙娱乐
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-800/50'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 text-sm font-medium text-foreground-300 hover:text-foreground-50 hover:bg-background-800/50 rounded-lg transition-all duration-200 whitespace-nowrap flex items-center gap-1 cursor-pointer">
                游戏分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-900 border border-background-700/50 rounded-xl p-2 min-w-[200px] shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800/50 transition-all duration-150 whitespace-nowrap"
                    >
                      <div className="w-7 h-7 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </div>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-800/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-5 py-2 text-sm font-medium text-foreground-300 hover:text-foreground-50 border border-background-600/50 hover:border-background-400/50 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer">
              登录
            </button>
            <Link
              to="/"
              className="px-5 py-2 text-sm font-semibold text-background-950 bg-primary-500 hover:bg-primary-400 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden border-t border-background-700/30 py-4 pb-6 animate-in fade-in slide-in-from-top-2">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                className="px-4 py-3 text-sm font-medium text-foreground-200 hover:text-foreground-50 hover:bg-background-800/30 rounded-lg transition-colors"
              >
                首页
              </Link>
              <div className="px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wider">
                游戏分类
              </div>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-800/30 rounded-lg transition-colors"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="px-4 py-3 text-sm font-medium text-foreground-200 hover:text-foreground-50 hover:bg-background-800/30 rounded-lg transition-colors"
              >
                关于我们
              </Link>
              <div className="flex gap-3 px-4 pt-4">
                <button className="flex-1 px-4 py-2.5 text-sm font-medium text-foreground-200 border border-background-600/50 rounded-lg transition-all cursor-pointer">
                  登录
                </button>
                <Link
                  to="/"
                  className="flex-1 px-4 py-2.5 text-sm font-semibold text-center text-background-950 bg-primary-500 rounded-lg transition-all"
                >
                  立即注册
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}